<template>
  <div class="nuttrema-list-item-custom" v-if="group.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ $t(`label.${title}`) }}</span>
    </div>
    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.duration.style" :label="columns.duration.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.price.style" :label="columns.price.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.payment_status.style" :label="columns.payment_status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.status.style" :label="columns.status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>

        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group">

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text">
                <div class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="two-line-text__description">
                  <span>{{ item.outline }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :label="columns.duration.label" :style-props="columns.duration.style">
              <span v-if="item.start_date && item.end_date">{{ item.start_date | moment('ll') }} - {{ item.end_date | moment('ll') }}</span>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.price.style">
              {{ _get(item, 'total_price') }} {{ _get(item, 'Currency.symbol') }}
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.payment_status.style">
              {{ _get(item, 'payment_status') === 'paid' ? $t('label.yes') : $t('label.no') }}
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.status.style">
              <el-tag size="small" :type="statusType(item)">{{ $t(`label.${_get(item, 'status')}`) }}</el-tag>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                class="el-button el-button--text"
                :to="{ name: _get(meta, 'navigation.details'), params: { id: item.id }}">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';
import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

export default {
  name: 'page-sys-admin-instance-subscriptions-list',
  mixins: [NuttremaIndexListItem],
  props: {
    features: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaIconicaKcal,
  },
  data() {
    return {
      columns: {
        name: {
          label: 'label.name',
          style: {
            'min-width': '200px',
            'flex-basis': 'auto',
            'flex-grow': '1',
            height: '2.5em',
          },
        },
        duration: {
          label: 'label.duration',
          style: {
            'max-width': '200px',
            'min-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        includes: {
          label: 'label.includes',
          style: {
            'max-width': '100px',
            'min-width': '75px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        price: {
          label: 'label.price',
          style: {
            'min-width': '50px',
            'max-width': '75px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        payment_status: {
          label: 'label.payment_status',
          style: {
            'min-width': '50px',
            'max-width': '75px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        status: {
          label: 'label.status',
          style: {
            'min-width': '75px',
            'max-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
  methods: {
    statusType(item) {
      let style = 'info';
      const status = get(item, 'status');
      style = status === 'current' ? 'success' : (status === 'active' ? '' : style);
      return style;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/instance-subscriptions/list/cmpt-instance-subscriptions-list-item.vue